import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createComplaints, getComplaint, getComplaints} from "../services/complaints-services";
import { TApiResponse, TErrorMessage, TPager, TSuccess } from "@/types";
import toast from "react-hot-toast";






export function useCreateComplaint(
    onSuccess?: TSuccess<TApiResponse<null>>
) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn:(data:any)=> createComplaints(data),
        onSuccess: async (res) => {
            // Without this the complaints table keeps showing the pre-submission page.
            await queryClient.invalidateQueries({ queryKey: ["complaints"] });

            toast.success("successful created");
            
            onSuccess?.(res);
        },
        onError: (error: TErrorMessage) => {
            toast.error(error.response?.data.message ?? "");
        },
    })
}


export function useComplaints(options: {
    search?: string,
    pager?: TPager,
    filter?: Record<string, unknown>
})  {
    const { isLoading, isFetching, data } = useQuery({
        queryKey: ["complaints",options.search, {...options.pager, ...options.filter}],
        queryFn: () => getComplaints(options.search, options.pager, options.filter),
    });

    return { isLoading, isFetching, complaints: data }
}


export function useComplaint(id?: string) {
    const { isLoading, isFetching, data } = useQuery({
        queryKey: ["complaint", id],
        queryFn: () => getComplaint(id as string),
        enabled: !!id,
    });

    return { isLoading, isFetching, complaint: data?.results }
}
